<template>
    <modal-wrapper modalClass="modal--bg" :modalName="name">
        <div class="modal__header">
            <h1>Styleguide form modal</h1>
        </div>
        <div class="modal__content">

            <i class="icons icon-fire"></i>

            <p>Hier komt een tekst te staan om te vertellen wat er vervolgens gaat gebeuren.</p>

            <form class="form">
                <div class="form__item">
                    <label class="form__label">Reden</label>
                    <textarea class="form__input--text" placeholder="Vul hier de reden van de afwijzing in..." />
                </div>
            </form>

        </div>
        <div class="modal__footer">
            <div class="actions">
                <button class="actions__action--save" type="submit">Verstuur</button>
                <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">Ga terug</button>
            </div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import ModalWrapper from '@/components/general/ModalWrapper';

    @Component
    export default class StyleguideModal extends Vue {
        name = 'styleguide-modal-bg';
        selected1 = null;
        selected2 = null;
        selected3 = null;
        selected4 = null;
    }

    Vue.component('styleguide-modal', StyleguideModal);
</script>



// WEBPACK FOOTER //
// src/components/modals/styleguide/StyleguideModalBg.vue